import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Setting } from '../../../models/setting';
import { SettingGroup } from '../../../models/setting-group';
import { SettingType } from '../../../models/setting-type';

import { AlertService } from '../../../services/common/alert.service';
import { SettingService } from '../../../services/settings/setting.service';
import { SettingGroupService } from '../../../services/settings/setting-group.service';
import { SettingTypeService } from '../../../services/settings/setting-type.service';

@Component({
  selector: 'app-setting-form',
  templateUrl: './setting-form.component.html',
  styleUrls: ['./setting-form.component.css'],
})
export class SettingFormComponent implements OnInit {
  formSubmitted: boolean = false;
  formSubmitting: boolean = false;

  @Input() setting_id: number | undefined;
  @Output() formEvent: EventEmitter<string> = new EventEmitter();

  setting_group_id: number;
  settingGroups: Array<SettingGroup> = [];
  settingTypes: Array<SettingType> = [];
  setting: Setting = new Setting();

  constructor(private alertService: AlertService, private settingService: SettingService, private settingGroupService: SettingGroupService, private settingTypeService: SettingTypeService) {
    this.settingGroupService.getSettingGroups({}).then((response) => (this.settingGroups = response));
  }

  ngOnInit() {
    if (!this.setting_id) this.setting = new Setting();
    else
      this.settingService.getSetting(this.setting_id).then((response) => {
        this.setting = response.setting as Setting;
        this.setting_group_id = response.setting_group_id;
        this.onSettingGroupSelect();
      });
  }

  onSettingGroupSelect() {
    if (this.setting_group_id) this.settingTypeService.getSettingTypes(this.setting_group_id, {}).then((response) => (this.settingTypes = response));
  }

  fieldShowErrorMessage(field: any) {
    if (!field.valid && !field.disabled && this.formSubmitted) return true;
    else return false;
  }

  fieldBuildErrorMessage(field: any, field_name: string): string {
    let error_message = [];
    let errors = field.errors || {};
    if (errors.required) error_message.push(field_name + ' is required');
    if (errors.notUnique) error_message.push(field_name + ' "' + field.value + '" is already taken');
    return error_message.join('<br />');
  }

  submitForm(formValid: any) {
    let scope: SettingFormComponent = this;
    this.formSubmitted = true;
    if (formValid) {
      this.formSubmitting = true;
      if (this.setting.id)
        this.settingService
          .updateSetting(this.setting.id, this.setting)
          .then((response) => {
            this.formSubmitting = false;
            if (response && response.text) {
              this.alertService.alert_status_success(response.text);
              this.formEvent.emit('Setting Group updated');
            } else {
              this.alertService.alert_status_danger('Error updating setting group');
            }
          })
          .catch(() => {
            scope.formSubmitting = false;
            scope.alertService.alert_status_danger('Error updating setting group');
          });
      else
        this.settingService
          .createSetting(this.setting)
          .then((response) => {
            this.formSubmitting = false;
            if (response && response.text) {
              this.alertService.alert_status_success(response.text);
              this.formEvent.emit('Setting Group created');
            } else {
              this.alertService.alert_status_danger('Error creating setting group');
            }
          })
          .catch(() => {
            scope.formSubmitting = false;
            scope.alertService.alert_status_danger('Error creating setting group');
          });
    }
  }
}
